import { Injectable } from '@angular/core';
import {
  BankAccountViewModel,
  IAllBankAccountInformationResponse,
} from '@models/bank-account.class';
import { Store } from '@ngrx/store';
import { Map } from 'immutable';
import { isEmpty } from 'lodash';
import { Observable, throwError as observableThrowError } from 'rxjs';
import {
  catchError,
  filter,
  map,
  pluck,
  switchMap,
  take,
} from 'rxjs/operators';
import { AppState } from 'src/app';
import { selectContractId } from 'src/app/state/selectors/current-contract.selectors';
import { NotificationService } from 'src/core/services/notification.service';
import { ApiGatewayService } from 'src/shared';

@Injectable()
export class CashService {
  private appConfiguration$: Observable<any>;
  private gbmAPI: string;
  private currentContractId$: Observable<string>;

  constructor(
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private apiGatewayService: ApiGatewayService,
  ) {
    this.appConfiguration$ = this.store.select('config');
    this.currentContractId$ = this.store
      .select(selectContractId)
      .pipe(filter(Boolean)) as Observable<string>;
    this.appConfiguration$
      .pipe(
        filter((mapShadowed: any) => Map.isMap(mapShadowed)),
        map((mapShadowed: any) => mapShadowed.get('api')),
        take(1),
      )
      .subscribe((api: string) => (this.gbmAPI = api));

    this.currentContractId$ = this.store
      .select(selectContractId)
      .pipe(filter(Boolean)) as Observable<string>;
  }

  getBankData(contractId: string): Observable<BankAccountViewModel[]> {
    return this.getAllBankAccountInformation(contractId).pipe(
      map((accounts: any) => {
        return !isEmpty(accounts)
          ? accounts.map((item: IAllBankAccountInformationResponse) =>
              BankAccountViewModel.fromOldJSON(item),
            )
          : [];
      }),
      catchError((error: any) => {
        this.notificationService.showServiceError(error);
        return observableThrowError(error);
      }),
    );
  }

  /// FIXME: This function can be delete and merge above but tradeCash test are crashing if we do
  getAllBankAccountInformation(contractId: string): Observable<any> {
    return this.apiGatewayService.post(
      `${this.gbmAPI}api/Cash/getAllBankAccountInformation`,
      {
        accountId: contractId,
        contractId,
      },
    );
  }

  getDepositsWithDrawals(contractId: string, days: number): Observable<any> {
    return this.apiGatewayService.post(
      `${this.gbmAPI}api/Cash/getDepositsWithDrawals/${days}`,
      { contractId },
    );
  }

  getCLABE(contractId: string): Observable<any> {
    return this.apiGatewayService
      .post(`${this.gbmAPI}api/Cash/getDepositAccountInformation`, {
        contractId,
      })
      .pipe(
        catchError((error: any) => {
          this.notificationService.showServiceError(error);

          return observableThrowError(error);
        }),
      );
  }

  public getCurrentClabe$(): Observable<string> {
    return this.currentContractId$.pipe(
      switchMap((contractId: string) => this.getCLABE(contractId)),
      pluck('response'),
    );
  }
}
